import { IResourceComponentsProps } from "@pankod/refine-core"

export const CustomizableContentCreate: React.FC<IResourceComponentsProps> = () => {
    return (
        <></>
    )
}